<template>
  <div>
    <div class="product-item-wrap emb-card">
      <div>
        <div class="thumb-warp">
          <router-link :to="detailPage(data.More_details_page_link)">
            <img :src="data.Product_Image_626_x_800px" :alt="data.Name" />
          </router-link>
          <div class="wishlist-icon">
            <v-btn @click="addItemToWishlist(data)" icon>
              <v-icon class="grey--text">favorite</v-icon>
            </v-btn>
          </div>
          <div class="add-to-cart">
            <v-btn
              :disabled="!data.Is_Stock_Available"
              class="accent"
              small
              icon
              @click="addProductToCart(data)"
            >
              <v-icon>shopping_cart</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="emb-card-content pa-4">
          <h5 class="font-weight-medium text-capitalize">{{data.Name}}</h5>
          <div class="emb-meta-info layout align-center justify-space-between">
            <div class="inline-block">
              <h6 class="accent--text">
                <!-- <emb-currency-sign></emb-currency-sign> -->
                {{$n(data.sellingPrice/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency)}}
              </h6>
            </div>
            <!-- <div class="inline-block">
              <v-rating
                v-model="data.rating"
                small
                background-color="warning"
                readonly
                color="warning"
              ></v-rating>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../services/utils/cms-helper";

export default {
  props: ["data", "colxs", "colsm", "colmd", "collg", "colxl"],
  computed: {
    ...mapGetters(["cart", "wishlist", "selectCurrency"]),
  },
  methods: {
    addProductToCart(item) {
      if (this.checkSignInOrNot()) {
        this.$snotify.success(this.cmsRequestFunctions.getValidationMsgByCode("M034"), {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
          showProgressBar: false,
        });
        setTimeout(() => {
          this.$store.dispatch("addProductToCart", item);
        }, 500);
      } else {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M033"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
      }
    },
    addItemToWishlist(product) {
      if (this.checkSignInOrNot()) {
        this.$snotify.success(this.cmsRequestFunctions.getValidationMsgByCode("M035"), {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
          showProgressBar: false,
        });
        setTimeout(() => {
          this.$store.dispatch("addItemToWishlist", product);
        }, 500);
      } else {
        this.$snotify.warning(
          this.cmsRequestFunctions.getValidationMsgByCode("M033"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
      }
    },
    checkSignInOrNot() {
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined) {
        return true;
      } else {
        return false;
      }
    },
    detailPage(url) {
      if (url != "") {
        url = url.split("/Template/")[1];
        url = url.split(".").slice(0, -1).join(".");
        url = "/product-details?page=" + url;
      } else {
        url = "#";
      }
      return url;
    },
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
  },
};
</script>